/**
 * Klarna payment method - uses shared BNPL factory.
 */

import { SHORT_POPUP_CLOSED_GRACE_MS } from "./bnpl-lifecycle";
import {
  type BnplCheckoutResponse,
  type BnplCustomerInfo,
  type BnplSubmitOptions,
  createBnplPaymentMethod,
} from "./bnpl-shared";

export type KlarnaCustomerInfo = BnplCustomerInfo;

export type KlarnaSubmitOptions = BnplSubmitOptions;

export type KlarnaCheckoutResponse = BnplCheckoutResponse;

const KlarnaPaymentMethod = createBnplPaymentMethod({
  name: "klarna",
  endpointPath: "klarna",
  supportsSetupFutureUsage: true,
  popupClosedGraceMs: SHORT_POPUP_CLOSED_GRACE_MS,
});

export default KlarnaPaymentMethod;
